/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PetAllergyModel,
  PetAttributeDataModel,
  PetAvatarModel,
  PetBreedModel,
  PetMedicalConditionModel,
  PetMedicationAllergyModel,
  PetMedicationModel,
  PetPrimaryDisciplineModel,
  PetRidingStyleModel,
  PetTypeModel,
} from '../models';
import {
    PetAllergyModelFromJSON,
    PetAllergyModelToJSON,
    PetAttributeDataModelFromJSON,
    PetAttributeDataModelToJSON,
    PetAvatarModelFromJSON,
    PetAvatarModelToJSON,
    PetBreedModelFromJSON,
    PetBreedModelToJSON,
    PetMedicalConditionModelFromJSON,
    PetMedicalConditionModelToJSON,
    PetMedicationAllergyModelFromJSON,
    PetMedicationAllergyModelToJSON,
    PetMedicationModelFromJSON,
    PetMedicationModelToJSON,
    PetPrimaryDisciplineModelFromJSON,
    PetPrimaryDisciplineModelToJSON,
    PetRidingStyleModelFromJSON,
    PetRidingStyleModelToJSON,
    PetTypeModelFromJSON,
    PetTypeModelToJSON,
} from '../models';

export interface PetAttributeApiGetPetAvatarRequest {
    id: number;
}

export interface PetAttributeApiGetPetAvatarsRequest {
    petTypeId?: number;
}

export interface PetAttributeApiGetPetBreedsRequest {
    petTypeId?: number;
}

export interface PetAttributeApiGetPetPrimaryDisciplinesRequest {
    ridingStyle?: string;
}

/**
 * 
 */
export class PetAttributeApi extends runtime.BaseAPI {

    /**
     * Get pet allergies
     * Get Pet Allergies
     */
    async getPetAllergiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetAllergyModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-allergies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetAllergyModelFromJSON));
    }

    /**
     * Get pet allergies
     * Get Pet Allergies
     */
    async getPetAllergies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetAllergyModel>> {
        const response = await this.getPetAllergiesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get pet attribute data such as types, breeds, etc.
     * Get Pet Attribute Data
     */
    async getPetAttributeDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetAttributeDataModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-attribute-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetAttributeDataModelFromJSON(jsonValue));
    }

    /**
     * Get pet attribute data such as types, breeds, etc.
     * Get Pet Attribute Data
     */
    async getPetAttributeData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetAttributeDataModel> {
        const response = await this.getPetAttributeDataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a pet avatar for a given avatar ID
     * Get Pet Avatar
     */
    async getPetAvatarRaw(requestParameters: PetAttributeApiGetPetAvatarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PetAvatarModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPetAvatar.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-avatars/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PetAvatarModelFromJSON(jsonValue));
    }

    /**
     * Get a pet avatar for a given avatar ID
     * Get Pet Avatar
     */
    async getPetAvatar(requestParameters: PetAttributeApiGetPetAvatarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PetAvatarModel> {
        const response = await this.getPetAvatarRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get pet avatars
     * Get Pet Avatars
     */
    async getPetAvatarsRaw(requestParameters: PetAttributeApiGetPetAvatarsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetAvatarModel>>> {
        const queryParameters: any = {};

        if (requestParameters.petTypeId !== undefined) {
            queryParameters['petTypeId'] = requestParameters.petTypeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-avatars`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetAvatarModelFromJSON));
    }

    /**
     * Get pet avatars
     * Get Pet Avatars
     */
    async getPetAvatars(requestParameters: PetAttributeApiGetPetAvatarsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetAvatarModel>> {
        const response = await this.getPetAvatarsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get pet breeds
     * Get Pet Breeds
     */
    async getPetBreedsRaw(requestParameters: PetAttributeApiGetPetBreedsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetBreedModel>>> {
        const queryParameters: any = {};

        if (requestParameters.petTypeId !== undefined) {
            queryParameters['petTypeId'] = requestParameters.petTypeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-breeds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetBreedModelFromJSON));
    }

    /**
     * Get pet breeds
     * Get Pet Breeds
     */
    async getPetBreeds(requestParameters: PetAttributeApiGetPetBreedsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetBreedModel>> {
        const response = await this.getPetBreedsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get pet medical conditions
     * Get Pet Medical Conditions
     */
    async getPetMedicalConditionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetMedicalConditionModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-medical-conditions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetMedicalConditionModelFromJSON));
    }

    /**
     * Get pet medical conditions
     * Get Pet Medical Conditions
     */
    async getPetMedicalConditions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetMedicalConditionModel>> {
        const response = await this.getPetMedicalConditionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get pet medication allergies
     * Get Pet Medication Allergies
     */
    async getPetMedicationAllergiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetMedicationAllergyModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-medication-allergies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetMedicationAllergyModelFromJSON));
    }

    /**
     * Get pet medication allergies
     * Get Pet Medication Allergies
     */
    async getPetMedicationAllergies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetMedicationAllergyModel>> {
        const response = await this.getPetMedicationAllergiesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get pet medications
     * Get Pet Medications
     */
    async getPetMedicationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetMedicationModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-medications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetMedicationModelFromJSON));
    }

    /**
     * Get pet medications
     * Get Pet Medications
     */
    async getPetMedications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetMedicationModel>> {
        const response = await this.getPetMedicationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get pet primary disciplines
     * Get Pet Primary Disciplines
     */
    async getPetPrimaryDisciplinesRaw(requestParameters: PetAttributeApiGetPetPrimaryDisciplinesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetPrimaryDisciplineModel>>> {
        const queryParameters: any = {};

        if (requestParameters.ridingStyle !== undefined) {
            queryParameters['ridingStyle'] = requestParameters.ridingStyle;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-primary-disciplines`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetPrimaryDisciplineModelFromJSON));
    }

    /**
     * Get pet primary disciplines
     * Get Pet Primary Disciplines
     */
    async getPetPrimaryDisciplines(requestParameters: PetAttributeApiGetPetPrimaryDisciplinesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetPrimaryDisciplineModel>> {
        const response = await this.getPetPrimaryDisciplinesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get pet riding styles
     * Get Pet Riding Styles
     */
    async getPetRidingStylesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetRidingStyleModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-riding-styles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetRidingStyleModelFromJSON));
    }

    /**
     * Get pet riding styles
     * Get Pet Riding Styles
     */
    async getPetRidingStyles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetRidingStyleModel>> {
        const response = await this.getPetRidingStylesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get pet types
     * Get Pet Types
     */
    async getPetTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PetTypeModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/petprofile/v1/pet-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PetTypeModelFromJSON));
    }

    /**
     * Get pet types
     * Get Pet Types
     */
    async getPetTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PetTypeModel>> {
        const response = await this.getPetTypesRaw(initOverrides);
        return await response.value();
    }

}
